import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from '../services/header.service';
import { TokenManager } from '../Globals';
import { MainLoadingService } from '../services/main-loading.service';
import { ThemeSettingService } from '../services/theme-setting.service';
var ActionAndNavigateComponent = /** @class */ (function () {
    function ActionAndNavigateComponent(route, headerService, tokenManager, router, mainLoadingService, themeSettingService) {
        var _this = this;
        this.route = route;
        this.headerService = headerService;
        this.tokenManager = tokenManager;
        this.router = router;
        this.mainLoadingService = mainLoadingService;
        this.themeSettingService = themeSettingService;
        this.userId = '';
        this.action = '';
        this.parameter = '';
        this.isBusy = false;
        this.route.queryParams.subscribe(function (params) {
            if (params['userId'])
                _this.userId = params['userId'];
            if (params['action'])
                _this.action = params['action'];
            if (params['parameter'])
                _this.parameter = params['parameter'];
        });
    }
    ActionAndNavigateComponent.prototype.ngOnInit = function () {
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        this.path = this.route.snapshot.paramMap.get("path");
        this.actionAndNavigate();
    };
    ActionAndNavigateComponent.prototype.actionAndNavigate = function () {
        var _this = this;
        this.isBusy = true;
        this.headerService.actionAndNavigateNew(this.path, this.userId, this.action, this.parameter).subscribe(function (result) {
            // this.isBusy = false;
            var parse = JSON.parse(result);
            if (parse) {
                if (parse["NavigateTo"]) {
                    if (parse["NavigateTo"].toLowerCase() == "login") {
                        _this.tokenManager.store("BRNHoldKey", parse["Key"]);
                        _this.router.navigate(['/' + parse["NavigateTo"]]);
                    }
                    else {
                        _this.tokenManager.delete("BRNHoldKey");
                        _this.tokenManager.store("BRNActionKey", parse["Key"]);
                        _this.router.navigate(['/' + parse["NavigateTo"]]);
                    }
                }
                else {
                    _this.tokenManager.store("BRNHoldKey", parse["Key"]);
                    _this.router.navigate(['/login']);
                }
            }
        }, function (error) {
            _this.isBusy = false;
        });
    };
    return ActionAndNavigateComponent;
}());
export { ActionAndNavigateComponent };
